import React from "react";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import { useAppSelector } from "../../../../../src/app/store";
import { useUserGroupMembership } from "../../../../../src/features/auth/logic/rbac";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import { selectStageConfigByStage } from "../../logic/slice";

const FrmdAdminDoAssignmentStage: React.FC = () => {
  const { isFrmdAdmin } = useUserGroupMembership();

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.FRMD_ADMIN_DO_ASSIGNMENT));

  if (isFrmdAdmin) {
    return (
      <WorkflowStageBanner
        title="Appoint Dealing Officer"
        description="Designate the Dealing Officer to manage the case lifecycle and to nominate IO Appointing Authority."
        actions={stageConfig?.actions}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Pending with FRMD to Appoint Dealing Officer"
    />
  );
};

export default FrmdAdminDoAssignmentStage;
